<template>
  <page layout="tabbed">
    <page-header :title="$t('Automations_Title')" :breadcrumbs="breadcrumbs">
      <template slot="actions">
        <router-link
          :to="exportCreateRoute"
          v-if="
            $route.name === 'AutomationExports' &&
              $can('UserPersonalData::Export') &&
              $can('manageAutomation')
          "
        >
          <el-button type="primary" icon="el-icon-plus">
            {{ $t('Automations_Action_CreateExport') }}
          </el-button>
        </router-link>
        <router-link
          :to="importCreateRoute"
          v-if="$route.name === 'AutomationImports' && $can('manageAutomation')"
        >
          <el-button type="primary" icon="el-icon-plus">
            {{ $t('Automations_Action_CreateImport') }}
          </el-button>
        </router-link>
      </template>
    </page-header>

    <page-tabs :tabs="tabs"></page-tabs>
  </page>
</template>

<script>
import Page from '@/common/components/page/Page'
import PageHeader from '@/common/components/page/PageHeaderNew'
import PageTabs from '@/common/components/page/PageTabs'
import { projectRoute } from '@/core/helpers'

export default {
  name: 'AutomationsPage',

  components: {
    Page,
    PageHeader,
    PageTabs
  },

  computed: {
    exportCreateRoute() {
      return projectRoute({
        name: 'AutomationExportCreate'
      })
    },
    importCreateRoute() {
      return projectRoute({
        name: 'AutomationImportCreate'
      })
    },
    tabs() {
      return [
        {
          title: this.$t('Automations_Tab_Imports'),
          route: projectRoute({ name: 'AutomationImports' })
        },
        {
          title: this.$t('Automations_Tab_Exports'),
          route: projectRoute({ name: 'AutomationExports' })
        }
      ]
    },

    breadcrumbs() {
      return [
        {
          label: this.$t('Automations_Breadcrumb_Data')
        },
        {
          label: this.$t('Automations_Breadcrumb_Automations')
        }
      ]
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/automations/pages/AutomationsPage.vue